import { render } from "./ForgotPasswordPropsCmp.vue?vue&type=template&id=c7578ae2"
import script from "./ForgotPasswordPropsCmp.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__